import React from 'react';
import { Form } from 'react-bootstrap';

const DisabledToggle = ({ includeDisabled, onChange, label = "Incluir deshabilitados", className = "me-3" }) => {
    return (
        <Form.Check 
            type="switch"
            id="include-disabled-switch"
            label={label}
            checked={includeDisabled}
            onChange={(e) => onChange(e.target.checked)}
            className={className}
        />
    );
};

export default DisabledToggle;